import { useTranslation } from 'react-i18next';
import discuss_your_idea from '../images/discuss_your_idea.png'

function Showcase() {
  const { t } = useTranslation();

  return (
    <section className="section showcase-section">
      <div className="showcase-card">
        <div className="showcase-image">
           <img src={discuss_your_idea} alt="Example WillowTec project preview" />
        </div>

        <div className="showcase-content">
          <div className="eyebrow">{t('showcase.eyebrow')}</div>
          <h2>{t('showcase.title')}</h2>
          <p>{t('showcase.description')}</p>
          <a href="#contact" className="button primary">
            {t('showcase.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default Showcase;
